/**
 * DOM helpers.
 */
import { yt } from "./icons.js";

export function V(e, t = null, ...n) {
    let r = document.createElement(e);
    for (let [e, n] of Object.entries(t ?? {})) n != null && n !== !1 && (e === `class` ? r.className = String(n) : e === `dataset` ? Object.assign(r.dataset, n) : e.startsWith(`on`) && typeof n == `function` ? r.addEventListener(e.slice(2).toLowerCase(), n) : r.setAttribute(e, n === !0 ? `` : String(n)));
    for (let e of n.flat()) e != null && e !== !1 && r.append(e instanceof Node ? e : String(e));
    return r
}

export function bt(e) {
    let t = document.createElement(`template`);
    return t.innerHTML = yt[e], t.content.firstElementChild
}

export function xt(e, t, n = {}) {
    let r = V(`button`, {
        class: n.primary ? `btn primary` : `btn`,
        type: `button`,
        "data-nav": !0
    }, n.icon && bt(n.icon), e);
    return r.addEventListener(`click`, () => !r.disabled && t()), r
}

export function St(e, t, n) {
    return V(`button`, {
        class: `menu-item`,
        type: `button`,
        "data-nav": !0,
        onClick: n
    }, bt(t), V(`span`, {
        class: `label`
    }, e))
}

export function Ct(e, t = `key`) {
    return V(`span`, {
        class: `cap ${t}`
    }, e)
}

export function wt(e) {
    return V(`div`, {
        class: `panel modal`
    }, V(`div`, {
        class: `modal-head`
    }, bt(e.icon), V(`h2`, null, e.title)), V(`div`, {
        class: `modal-body`
    }, e.body), V(`div`, {
        class: `modal-foot`
    }, ...e.foot))
}
